// API Endpoints
export const API_URL = "https://api-leadgen.eventegration.com/graphql/";
// export const API_URL = "http://localhost:4002/graphql";
export const IMAGES_API_URL = "https://api-admin.eventegration.com/public/";
// export const API_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:4002/graphql";
// export const IMAGES_API_URL =
//   process.env.REACT_APP_IMAGES_API_URL || "http://localhost:4000/images/";

// Local Storage Keys
export const AUTH_TOKEN_KEY = "auth.exhibitor.eventegration.com";

// Date formats
export const DATE_FORMAT = "dd MMM yyyy";
export const TIME_FORMAT = "HH:mm";
export const DATETIME_FORMAT = "dd MMM yyyy, HH:mm";

// Lead Types
export const LEAD_TYPES = [
  { value: "general", label: "General Interest" },
  { value: "hot", label: "Hot Lead" },
  { value: "warm", label: "Warm Lead" },
  { value: "cold", label: "Cold Lead" },
];

// Roles
export const ROLES = [
  { value: "admin", label: "Admin" },
  { value: "staff", label: "Staff" },
  { value: "visitor", label: "Visitor" },
];

// Validation
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PASSWORD_MIN_LENGTH = 6;

export const downloadFile = (document, content, filename) => {
  const element = document.createElement("a");
  const file = new Blob([content], {
    type: "text/plain",
  });
  element.href = URL.createObjectURL(file);
  element.download = filename;
  document.body.appendChild(element);
  element.click();
};

export function csvToArray(str, delimiter = ",") {
  // slice from start of text to the first \n index
  // use split to create an array from string by delimiter
  const headers = str
    .slice(0, str.indexOf("\n"))
    .split(delimiter)
    .map((h) => h.trim());

  // slice from \n index + 1 to the end of the text
  // use split to create an array of each csv value row
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");
  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      object[header] = values[index]?.trim() || "";
      return object;
    }, {});
    return el;
  });

  // return the array
  return arr;
}
